import React from "react";

import { useLocation } from "react-router-dom";
import whatsapp from "../assets/whatsapp.webp";
import "../styles/app.css";

function Contact() {
  const pathname = useLocation().pathname;

  let phoneNumber;

  if (
    pathname.includes("/resin-art") ||
    pathname.includes("/texture-paint") ||
    pathname.includes("/kidsShirt") ||
    pathname.includes("/texturePaint")
  ) {
    phoneNumber = "3171234366";
  }

  if (
    pathname.includes("/men-shirts") ||
    pathname.includes("/women-shirts") ||
    pathname.includes("/menShirts") ||
    pathname.includes("/womenShirts")
  ) {
    phoneNumber = "3154725501";
  }

  const handleContact = () => {
    const message = `Hello! This is a message from FesiRH110. \n\nI need Help with: `;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=%2B92${phoneNumber}&text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="contact-container" onClick={handleContact}>
      <h5 className="chat-text">Chat With Us</h5>
      <img src={whatsapp} alt="WhatsApp Icon" />
    </div>
  );
}

export default Contact;
